var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAirplaneTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.59,
    x2: 345.352,
    y1: 88.413,
    y2: 322.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.605,
    x2: 389.816,
    y1: 294.938,
    y2: 229.065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0656,
    stopColor: "#b8e27b",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#85cc7f",
    stopOpacity: 0.237
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4058,
    stopColor: "#5cb981",
    stopOpacity: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5695,
    stopColor: "#3baa83",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    stopColor: "#24a085",
    stopOpacity: 0.726
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#169986",
    stopOpacity: 0.873
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.376,
    x2: 334.138,
    y1: 140.981,
    y2: 375.358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.728,
    x2: 255.123,
    xlinkHref: "#lg1",
    y1: 132.378,
    y2: 430.171
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.628,
    x2: 521.667,
    xlinkHref: "#lg1",
    y1: 202.989,
    y2: 357.028
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0287,
    stopColor: "#e9d6f7",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2203,
    stopColor: "#c5b5de",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4138,
    stopColor: "#aa9bcb",
    stopOpacity: 0.414
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6078,
    stopColor: "#9688bd",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8028,
    stopColor: "#8a7db5",
    stopOpacity: 0.803
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.468,
    x2: 215.713,
    xlinkHref: "#lg2",
    y1: 289.637,
    y2: -45.273
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.072,
    x2: 247.165,
    y1: 134.511,
    y2: 221.981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.144,
    x2: 200.753,
    y1: 308.658,
    y2: 138.267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.586,
    x2: 294.621,
    y1: 166.282,
    y2: 238.317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.618,
    x2: 241.618,
    xlinkHref: "#lg2",
    y1: 370.522,
    y2: 438.143
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.581 95.993h-74.863c-10.725 0-19.419 8.694-19.419 19.419 0-10.725-8.694-19.419-19.419-19.419h-330.694c-10.725 0-19.419 8.694-19.419 19.419v226.607c0 10.725 8.694 19.419 19.419 19.419h330.694c10.725 0 19.419-8.694 19.419-19.419 0 10.725 8.694 19.419 19.419 19.419h74.863c10.725 0 19.419-8.694 19.419-19.419v-226.607c0-10.725-8.694-19.419-19.419-19.419z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 342.019v-174.756l-31.453-31.452c-3.561-4.15-8.834-4.789-14.732-4.789h-74.863c-10.725 0-19.419 8.694-19.419 19.419v210.997h7.346c10.725 0 19.419-8.694 19.419-19.419 0 10.725 8.694 19.419 19.419 19.419h74.863c10.726 0 19.42-8.694 19.42-19.419z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.367 148.562h-74.863c-10.725 0-19.419 8.694-19.419 19.419 0-10.725-8.694-19.419-19.419-19.419h-330.695c-10.725 0-19.419 8.694-19.419 19.419v226.607c0 10.725 8.694 19.419 19.419 19.419h330.694c10.725 0 19.419-8.694 19.419-19.419 0 10.725 8.694 19.419 19.419 19.419h74.863c10.725 0 19.419-8.694 19.419-19.419v-226.607c.001-10.725-8.693-19.419-19.418-19.419z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m350.114 394.467h-330.694c-10.725 0-19.419-8.694-19.419-19.419v-226.607c0-10.725 8.694-19.419 19.419-19.419h330.694c10.725 0 19.419 8.694 19.419 19.419v226.607c0 10.725-8.694 19.419-19.419 19.419z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.953 394.467h74.863c10.725 0 19.419-8.694 19.419-19.419v-226.607c0-10.725-8.694-19.419-19.419-19.419h-74.863c-10.725 0-19.419 8.694-19.419 19.419v226.607c-.001 10.725 8.694 19.419 19.419 19.419z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.229 188.965c.028-.176.047-1.355.047-1.538 0-.799-.283-1.543-.772-2.174l-23.467-23.506c-.939-1.11-2.53-.84-4.334-.84-.268 0-.528.027-.785.058l-1.349-2.839c-.503-.686-4.669-4.669-4.669-4.669h-14.32c-1.168 0-1.007.411-.673 1.305l12.793 34.228c-13.839.687-28.725 2.085-39.797 3.958l-.19-1.265c-.288-.402-.824-.651-1.405-.651h-.391l-7.543-7.688c-.288-.402-.824-.651-1.405-.651h-5.165c-.998 0-.757.714-.596 1.499l2.5 12.223c-4.753 1.55-7.556 2.254-7.556 4.043 0 1.407.739 1.761 3.791 3.029-.079.212-.122 1.425-.122 1.64 0 .979 1.843 2.931 3.38 3.848l-1.994 8.749c-.161.786-.401 1.499.596 1.499l163.227 163.318c.965-2.306 1.502-4.837 1.502-7.493 0 10.725 8.694 19.419 19.419 19.419h74.863c10.725 0 19.419-8.694 19.419-19.419v-18.82l-157.966-157.967c-1.747-4.394-26.243-9.233-27.038-9.296z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.23 148.437v52.023h-483.23v-52.023c0-10.721 8.691-19.412 19.423-19.412h330.695c10.721 0 19.412 8.691 19.412 19.412 0-10.721 8.702-19.412 19.423-19.412h74.866c10.72 0 19.411 8.691 19.411 19.412z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.267 198.261c-1.747-4.394-23.297-8.542-23.297-8.542l-27.933-27.971c-.939-1.11-2.862-.813-3.119-.782l-8.018-7.508h-14.32c-1.168 0-1.007.411-.673 1.305l12.793 34.228c-13.839.687-27.725 2.085-38.797 3.958l-10.677-9.749c-.318-.323-.752-.506-1.205-.506h-5.216c-.998 0-.757.714-.596 1.499l2.5 12.223c-4.753 1.55-7.556 2.254-7.556 4.043h-1 129.312z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e3ceef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.604 319.311h-161.017c-3.886 0-7.036-3.15-7.036-7.036v-12.191c0-3.886 3.15-7.036 7.036-7.036h161.018c3.886 0 7.036 3.15 7.036 7.036v12.191c-.001 3.886-3.151 7.036-7.037 7.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.164 363.99h-85.577c-3.886 0-7.036-3.15-7.036-7.036v-12.191c0-3.886 3.15-7.036 7.036-7.036h85.577c3.886 0 7.036 3.15 7.036 7.036v12.191c0 3.886-3.15 7.036-7.036 7.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.164 249.975h-85.577c-3.886 0-7.036-3.15-7.036-7.036v-12.191c0-3.886 3.15-7.036 7.036-7.036h85.577c3.886 0 7.036 3.15 7.036 7.036v12.191c0 3.885-3.15 7.036-7.036 7.036z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e3ceef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m443.012 319.311h-33.255c-3.886 0-7.036-3.15-7.036-7.036v-12.191c0-3.886 3.15-7.036 7.036-7.036h33.255c3.886 0 7.036 3.15 7.036 7.036v12.191c0 3.886-3.15 7.036-7.036 7.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.012 363.99h-33.255c-3.886 0-7.036-3.15-7.036-7.036v-12.191c0-3.886 3.15-7.036 7.036-7.036h33.255c3.886 0 7.036 3.15 7.036 7.036v12.191c0 3.886-3.15 7.036-7.036 7.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.012 249.975h-33.255c-3.886 0-7.036-3.15-7.036-7.036v-12.191c0-3.886 3.15-7.036 7.036-7.036h33.255c3.886 0 7.036 3.15 7.036 7.036v12.191c0 3.885-3.15 7.036-7.036 7.036z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288.011 187.687-9.649-13.152c1.099-.765 1.794-1.89 1.794-3.145 0-2.304-2.34-4.172-5.227-4.172-.617 0-1.208.086-1.757.243l-.127-.173c1.151-.765 1.884-1.918 1.884-3.207 0-2.304-2.34-4.172-5.227-4.172-.659 0-1.288.098-1.869.276l-4.934-6.726c-.676-.921-1.913-1.487-3.251-1.487h-11.068c-1.168 0-2.007.898-1.673 1.792l12.793 34.228c-14.842.737-29.74 2.291-41.16 4.372l-7.165-10.018c-.288-.402-.824-.651-1.405-.651h-5.165c-.998 0-1.757.714-1.596 1.499l2.5 12.223c-4.753 1.55-7.556 3.254-7.556 5.043s2.802 3.493 7.556 5.043l-2.5 12.223c-.161.786.599 1.499 1.596 1.499h5.166c.581 0 1.117-.248 1.405-.651l7.165-10.018c11.421 2.081 26.318 3.635 41.16 4.371l-12.793 34.229c-.334.894.504 1.792 1.673 1.792h11.068c1.337 0 2.575-.566 3.251-1.488l4.934-6.726c.581.178 1.21.276 1.869.276 2.887 0 5.227-1.868 5.227-4.172 0-1.289-.733-2.442-1.884-3.207l.127-.173c.549.157 1.141.243 1.757.243 2.887 0 5.227-1.868 5.227-4.172 0-1.255-.695-2.38-1.794-3.145l9.649-13.151c27.668-1.005 37.682-6.34 37.682-12.773-.001-6.433-10.016-11.769-37.683-12.773z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.001 350.859v24.19c0 10.725 8.694 19.419 19.419 19.419h330.694c10.725 0 19.419-8.694 19.419-19.419 0 10.725 8.694 19.419 19.419 19.419h74.863c10.725 0 19.419-8.694 19.419-19.419v-24.19z",
    fill: "url(#SVGID_10_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirplaneTicket);
export default __webpack_public_path__ + "static/media/icon-airplane-ticket.95d5187bbaa54934630af9b6532d833e.svg";
export { ForwardRef as ReactComponent };